import { Page, BasicTransport, User, OpCo, Platform } from '../types';
declare global {
  interface Window {
    dataLayer: any[];
  }
}

function addToDataLayer(entry: { event: string; opCo: OpCo; platform: Platform; [key: string]: unknown }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(entry);
}

export async function createGoogleTagManagerTransport(opCo: OpCo, platform: Platform): Promise<BasicTransport> {
  const gtmTransport: BasicTransport = {
    async identify(user: User) {
      const { id, ...traits } = user;
      addToDataLayer({ event: 'Identify', opCo, platform, traits });
    },

    async page(page: Page) {
      addToDataLayer({ event: `Viewed ${page.category} ${page.type} page`, opCo, platform, ...page });
    },

    async track(event: string, properties: Record<string, unknown>) {
      addToDataLayer({ event, opCo, platform, ...properties });
    },
  };

  return gtmTransport;
}
